import { ACTIVITY_API } from "../../api/activity";

const state = {
    downloadActivityLoading: false,
    downloadActivityError: null,
};

const mutations = {
    SET_DOWNLOAD_ACTIVITY_LOADING(state, loading) {
        state.downloadActivityLoading = loading;
    },
    SET_DOWNLOAD_ACTIVITY_ERROR(state, error) {
        state.downloadActivityError = error;
    },
};

const actions = {
    /**
     * İndirme aktivitesi logla
     * @param {Object} context - Vuex context
     * @param {Object} payload - Activity bilgileri
     * @param {string} payload.activityType - Activity tipi (örn: "TABLE_DATA_DOWNLOADED")
     * @param {Object} payload.data - Activity için payload verisi
     * @returns {Promise<Object>} - { success: boolean, error?: string }
     */
    async logDownloadActivity({ commit }, { activityType, data }) {
        commit("SET_DOWNLOAD_ACTIVITY_LOADING", true);
        commit("SET_DOWNLOAD_ACTIVITY_ERROR", null);

        try {
            const response = await ACTIVITY_API.ACTIVITY.logDownload(activityType, data);
            commit("SET_DOWNLOAD_ACTIVITY_LOADING", false);
            
            if (response.data && response.data.success) {
                return { success: true };
            } else {
                const errorMsg = response.data?.error || "Activity log hatası";
                commit("SET_DOWNLOAD_ACTIVITY_ERROR", errorMsg);
                return { success: false, error: errorMsg };
            }
        } catch (error) {
            const errorMsg = error.response?.data?.error || error.message || "Bilinmeyen hata";
            commit("SET_DOWNLOAD_ACTIVITY_ERROR", errorMsg);
            commit("SET_DOWNLOAD_ACTIVITY_LOADING", false);
            console.error("logDownloadActivity error:", error);
            return { success: false, error: errorMsg };
        }
    },
};

const getters = {
    downloadActivityLoading: (state) => state.downloadActivityLoading,
    downloadActivityError: (state) => state.downloadActivityError,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

